var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "location-share" } },
    [
      _c(
        "div",
        {
          on: {
            click: function ($event) {
              _vm.showMap = true
            },
          },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.showMap
        ? _c(
            "Modal2",
            {
              ref: "location",
              attrs: { "show-footer": false },
              on: {
                cancel: function ($event) {
                  _vm.showMap = false
                },
              },
            },
            [
              _c(
                "l-map",
                {
                  ref: "map",
                  staticClass: "map",
                  attrs: { center: _vm.center, zoom: _vm.zoom },
                  on: { ready: _vm.ready, click: _vm.mapClick },
                },
                [
                  _c("l-tile-layer", { attrs: { url: _vm.url } }),
                  _vm._v(" "),
                  _c("l-marker", {
                    attrs: {
                      draggable: "",
                      icon: _vm.icons.default,
                      "lat-lng": _vm.center,
                    },
                    on: {
                      "update:latLng": function ($event) {
                        _vm.center = $event
                      },
                      "update:lat-lng": function ($event) {
                        _vm.center = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn mt-3 pointer",
                  class: { disabled: !_vm.locationEnabled },
                  on: { click: _vm.getCurrentLocation },
                },
                [
                  _c("md-icon", [_vm._v("my_location")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.useMyLocation")))]),
                  _vm._v(" "),
                  !_vm.locationEnabled
                    ? _c("div", { staticClass: "text-danger" }, [
                        _vm._v(
                          "(" +
                            _vm._s(_vm.$t("message.locationPermsNeeded")) +
                            ")"
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "mt-3 btn-success d-block",
                  on: { click: _vm.sendLocation },
                },
                [_vm._v(_vm._s(_vm.$t("message.send")))]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }